import { render, staticRenderFns } from "./CMSCustomFieldDetailShow.vue?vue&type=template&id=71f7b3b4&"
import script from "./CMSCustomFieldDetailShow.vue?vue&type=script&lang=js&"
export * from "./CMSCustomFieldDetailShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports